import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get Roles
export const getRoleList = createAsyncThunk("/get-role-list", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}adminuser/api/v1/get-role-list`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    return response; 
  } catch (error) {
    console.error("Error fetching Roles", error);

    return rejectWithValue(error.response?.data?.message || "Failed to fetch Roles");
  }
});
